<template>
	<div id="marketstudies-index"
		 class="app-home ui-styles"
		 :class="theme">
		<template class="view_container">

			<div class="loading_view" v-if="master_loading">
				<div class="view_spinner_container">
					<span style="color: rgb(0, 79, 146); margin: 0 auto;">
					<icon name="spinner" scale="4"
						  color="rgb(0, 79, 146)" spin></icon></span><br>
					<span>{{ $t('Loading')}}...</span>
				</div>
			</div>

			<div class="master_view">
				<side-nav-bar :adsOpen="adsOpen"></side-nav-bar>
				<div class="app-container">
					<bar>
					</bar>
					<h1>{{ $t('Ads_index') }}</h1>
					<vue-tabs>
						<v-tab :title="ads_index_text">
							<div class="tab_content">
								<div>
									<form class="bt-form">
										<div>
											<div @click.prevent="onCreateNewAd"
												 style="width: fit-content; margin-left: auto">
												<icon-button icon="plus-circle" :text="new_ad_button_text"
															 icon_color="black"
															 text_color="black" border_color="lightgray"></icon-button>
											</div>
										</div>
										<div class="section-container"
											 style="background-color: #fafafc; padding: 2rem;">
											<h3>{{ $t('Address_referral') }}</h3>
											<div class="field-container">

											</div>

											</div>
									</form>
								</div>








							</div>
						</v-tab>

					</vue-tabs>


					<bar>
					</bar>

				</div>
			</div>
		</template>
	</div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import Vue from 'vue'
    import _ from 'lodash'
    import moment from 'moment'
    import { dateMixin, localStorageMixin, objectsMixin } from '../../../mixins'
    import Spinner from '../../../components/Spinner.vue'
    import Search from '../../../components/ContactsSearch/Index.vue'
    import Editor from '../../../components/Editor/Index.vue'
    import Bar from '../../../components/Bar/Index.vue'
    import IconButton from '../../../components/IconButton/Index.vue'
    import SideNavBar from '../../../components/SideNavBar/Index.vue'

    import router from '../../../router/index.js'

    import Message from '../../../components/Message.vue'

    import Datatable from '../../../components/Datatable/datatable.vue'
    import DatatableColumn from '../../../components/Datatable/datatable-column.vue'
    import aggregators from '../../../aggregators/aggregators.js'
    import formatters from '../../../formatters/formatters.js'
    import Checkbox from '../../../components/Toggles/checkbox.vue'
    import Paginator from '../../../components/Paginator/paginator.vue'

    export default {
        name: 'ads-index',

        mixins: [
            dateMixin,
            localStorageMixin,
            objectsMixin
        ],

        data: () => ({
            master_loading: true,
            loading: true,
            query_comparables_loading: false,
            adsOpen: false,
            adOpen: false,
            editabletrue: true,
            error: null,
            success_message: null,
            queryComparableTypeValue: null,
            new_ad_button_text: Vue.i18n.translate('Add_ad_manually'),
            add_ad_text: Vue.i18n.translate('Add_ad'),
            query_ads_text: Vue.i18n.translate('Query_ads'),
            ads_index_text: Vue.i18n.translate('Ads_index'),
            ads_text: Vue.i18n.translate('Ads'),
            filter_placeholder: Vue.i18n.translate('Type_here_to_filter_paginated_data'),
            cancel_button_text: Vue.i18n.translate('Cancel'),
            goback_button_text: Vue.i18n.translate('Go_back') + ' ' + Vue.i18n.translate('without_saving'),
            goup_button_text: Vue.i18n.translate('Go_up') + ' ' + Vue.i18n.translate('without_saving'),
            save_button_text: Vue.i18n.translate('Save') + ' ' + Vue.i18n.translate('and') + ' ' + Vue.i18n.translate('go_up'),
            lat_lng_error_text: Vue.i18n.translate('Lat_lng_missing_error_text'),
            actions_text: Vue.i18n.translate('Actions'),
            duplicate_text: Vue.i18n.translate('Duplicate'),
            edit_text: Vue.i18n.translate('Edit'),
            delete_text: Vue.i18n.translate('Delete'),
            countryValue: null,
            municipalityValue: null,
            provinceValue: null,
            ad_table: {
                striped: true,
                editable: false,
                lineNumbers: true,
                filter: null,
                currency: 'EUR',
                dateFormat: 'DD/MM/YYYY',
                columns: [
                    {
                        id: 'address',
                        label: Vue.i18n.translate('Address'),
                        width: 30,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'appraisalfiles',
                        label: Vue.i18n.translate('Files'),
                        width: 10,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    /*
					{
						id: 'street_number',
						label: Vue.i18n.translate('Street_number'),
						width: null,
						sortable: true,
						groupable: false,
						aggregators: []
					},
					{
						id: 'floor',
						label: Vue.i18n.translate('Floor'),
						width: null,
						sortable: true,
						groupable: false,
						aggregators: []
					},
					{
						id: 'door',
						label: Vue.i18n.translate('door'),
						width: null,
						sortable: true,
						groupable: false,
						aggregators: []
					},
					{
						id: 'postal_code',
						label: Vue.i18n.translate('Postal_code'),
						width: null,
						sortable: true,
						groupable: false,
						aggregators: []
					},
					{
						id: 'municipality',
						label: Vue.i18n.translate('Municipality'),
						width: null,
						sortable: true,
						groupable: false,
						aggregators: []
					},
					*/
                    {
                        id: 'description',
                        label: Vue.i18n.translate('Description'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: []
                    },
                    {
                        id: 'date_modified',
                        label: Vue.i18n.translate('Last_modified'),
                        width: null,
                        sortable: true,
                        groupable: false,
                        aggregators: [],
                        formatter: function (value) {
                            return moment(value).format('DD/MM/YYYY HH:mm:ss')
                        }
                    }
                ],
                selected: []
            },

        }),

        created () {
            /*
            this.FETCH_ADS({path: 'ads'})
                .then(() => {
                    this.master_loading = false

                })
                */
            this.master_loading = false

        },

        components: {
            Bar,
            Message,
            IconButton,
            Spinner,
            Checkbox,
            Datatable,
            DatatableColumn,
            Paginator,
            SideNavBar
        },

        computed: {
            ...mapGetters([
                'theme',
                'currentLocale',
                'ads'
            ])
        },

        methods: {
            ...mapActions(
                [
                    'CREATE_NEW_AD',
                    'FETCH_ADS',
                    'RESET_AD',
                    'SET_AD',
                    'SET_APPRAISALFILE'
                ]),
            onCreateNewAd: function () {
                // console.log('hey')
                // console.log('ad: ')
                // console.log(this.ad)
                this.RESET_AD().then((res) => {
                    this.CREATE_NEW_AD({
                        path: 'temp_ads' + '/',
                    }).then((res) => {
                        this.$router.push({name: 'ad-editor', query: {id: res.key,  mcna: 'y'}})
                    })
                })
            },
            editAd: function (entity) {
                // console.log('edit ad...')
                this.SET_AD({path: 'ads' + '/' + entity.id + '/'}).then((res) => {
                    this.$router.push({name: 'ad-editor', query: {id: entity.id}})

                })
            }
        },
        head: {
            title: {
                //inner: Vue.i18n.translate('New_contact')
                inner: 'Ads'
            }

        }
    }
</script>


// WEBPACK FOOTER //
// AdsIndex.vue?250b0d66